import { useSearchParams } from "react-router-dom";
import { loginRedirect } from "@common/redirect";
import { Button, Card } from "@jkast90/kast-common/ui";
import styles from "./Confirmed.module.css";

export default function Confirmed() {
  const [searchParams] = useSearchParams();
  const redirect = loginRedirect(searchParams.get("redirect"));

  return (
    <div className={styles.page}>
      <Card padding="lg" className={styles.card}>
        <img src="/kd_logo.png" alt="Kast Dev" className={styles.logo} />

        <div className={styles.iconWrapper}>
          <svg
            className={styles.icon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            aria-hidden="true"
            focusable="false"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12l3 3 5-5" />
          </svg>
        </div>

        <h1 className={styles.title}>You're all set!</h1>

        <p className={styles.message}>Your email has been verified and your Kast Dev account is ready to go.</p>

        <Button as="a" href={redirect} variant="primary" className={styles.button}>
          Continue to Kast Dev
        </Button>
      </Card>
    </div>
  );
}
